'use client'

import { createContext, type ReactNode, useContext } from 'react'
import {
  flowsBasePathForSurface,
  templatesBasePathForSurface,
} from './url-helpers'

export type TemplatesSurface = 'app' | 'public'

const TemplatesSurfaceContext = createContext<TemplatesSurface>('app')

export function TemplatesSurfaceProvider({
  surface,
  children,
}: {
  surface: TemplatesSurface
  children: ReactNode
}) {
  return (
    <TemplatesSurfaceContext.Provider value={surface}>
      {children}
    </TemplatesSurfaceContext.Provider>
  )
}

export function useTemplatesSurface(): TemplatesSurface {
  return useContext(TemplatesSurfaceContext)
}

export function useTemplatesBasePath(): string {
  return templatesBasePathForSurface(useTemplatesSurface())
}

/** `/flows` inside the app, `/browse/flows` on the public mirror. */
export function useFlowsBasePath(): string {
  return flowsBasePathForSurface(useTemplatesSurface())
}
